module.exports = __webpack_public_path__ + "static/img/healthassess.6cb88636.png";